module.exports = __webpack_public_path__ + "img/image127.dc7e6473.jpg";